module.exports = __webpack_public_path__ + "static/media/img153.3133c21b.jpg";